import React from 'react';
import PropTypes from 'prop-types';

import Img from '../Img';

import styles from './splashV3.scss';

export const SplashScope = {
    GLOBAL: 'global',
    COMPONENT: 'component',
};

const SplashV3 = ({ scope }) => {
    const scopeClass = scope === SplashScope.GLOBAL ? '' : styles.limitToComponent;

    return (
        <div className={`${styles.loadingPage} ${scopeClass}`} data-testid={`splash.${scope}`}>
            <div className={styles.progressWrapper}>
                <div className={styles.progressBar} data-testid={`splash.${scope}.progress-bar`} />
            </div>
            <div className={styles.innerWrapper}>
                <div className={styles.iconWrapper}>
                    <Img src="/img/utr_sports/utr-sports-logo.svg" data-testid={`splash.${scope}.logo`} />
                </div>
            </div>
        </div>
    );
};

SplashV3.propTypes = {
    scope: PropTypes.oneOf(Object.values(SplashScope)),
};

SplashV3.defaultProps = {
    scope: SplashScope.GLOBAL,
};

export default SplashV3;
